<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
    <div fxFlex>Preview Fax</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content class="mat-typography" fxFlex style="background: gray;">
    <app-pdf-viewer *ngIf="data.pdfSource" [src]="data.pdfSource"
                (afterLoadComplete)="afterPdfLoaded()"
                style="display: block; height: 100%; width: 90%; margin: auto">
    </app-pdf-viewer>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Close</button>
  </mat-dialog-actions>
</div>
